import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { TextField, IconButton, Button, Autocomplete } from '@mui/material';
import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material';

const KitDetailsForm = forwardRef(({ modalTitle, isKit, initialRows = [], skuOnly = [] }, ref) => {
  const [rows, setRows] = useState([
    { id: '', itemSku: '', skuquantity: '', itemSkuError: '', quantityError: '' },
  ]);

  // Sync with parent-provided initialRows
  useEffect(() => {
    if (initialRows && initialRows.length > 0) {
      const mapped = initialRows.map(item => ({
        id: item.id,
        itemSku: item.item_sku || '',
        skuquantity: item.quantity || '',
        itemSkuError: '',
        quantityError: '',
      }));
      setRows(mapped);
    } else {
      setRows([{ id: '', itemSku: '', skuquantity: '', itemSkuError: '', quantityError: '' }]);
    }
  }, [initialRows]);

  // Expose validation method to parent
  useImperativeHandle(ref, () => ({
    validateAndGetRows: () => {
      let isValid = true;
      const validated = rows.map(row => {
        const errors = { ...row };
        if (!row.itemSku.trim()) {
          errors.itemSkuError = 'Item SKU is required';
          isValid = false;
        }
        if (
          !row.skuquantity.trim() ||
          isNaN(row.skuquantity) ||
          parseInt(row.skuquantity) <= 0
        ) {
          errors.quantityError = 'Quantity must be a positive number';
          isValid = false;
        }
        return errors;
      });
      setRows(validated);
      return isValid ? validated.map(({ id, itemSku, skuquantity }) => ({ id,item_sku: itemSku, quantity: skuquantity })) : null;
    }
  }));

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    if (field === 'itemSku') updated[index].itemSkuError = '';
    if (field === 'skuquantity') updated[index].quantityError = '';
    setRows(updated);
  };

  const addRow = () => {
    if (rows.length < 10) {
      setRows([...rows, { id: '', itemSku: '', skuquantity: '', itemSkuError: '', quantityError: '' }]);
    }
  };

  const removeRow = index => {
    const updated = rows.filter((_, i) => i !== index);
    setRows(updated);
  };

  return (
    <div style={{ margin: '20px 0' }}>
        <div
            style={{
              position: 'sticky',
              top: 0,
              display: 'flex',
              justifyContent: 'space-between',
              backgroundColor: '#fff',
              zIndex: 2,
              padding: '8px 0',
              borderBottom: '1px solid #eee',
            }}
          >
          <p>Items</p>
          <Button
            variant="outlined"
            onClick={addRow}
            disabled={rows.length >= 10}
            startIcon={<AddCircleOutline />}
          >
            Add Item
          </Button>
      </div>
      {rows.map((row, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '16px',
            padding: '12px',
            border: '1px solid #ccc',
            borderRadius: '8px',
            backgroundColor: '#f9f9f9',
          }}
        >
          <Autocomplete
            options={skuOnly}
            value={row.itemSku}
            onChange={(e, newValue) => handleChange(index, 'itemSku', newValue || '')}
            onInputChange={(e, newInputValue) => handleChange(index, 'itemSku', newInputValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Item Sku"
                variant="standard"
                error={!!row.itemSkuError}
                helperText={row.itemSkuError}
              />
            )}
            style={{ width: '50%' }}
            freeSolo
          />
          {/* <TextField
            label="Item Sku"
            value={row.itemSku}
            onInput={e => handleChange(index, 'itemSku', e.target.value)}
            variant={"standard"}
            // InputProps={{
            //   readOnly: modalTitle === 'Items Edit' || modalTitle === 'New Items Edit',
            // }}
            style={{ width: '50%' }}
            error={!!row.itemSkuError}
            helperText={row.itemSkuError}
          /> */}
          <TextField
            label="Quantity"
            value={row.skuquantity}
            onInput={e => handleChange(index, 'skuquantity', e.target.value)}
            // InputProps={{
            //   readOnly: isKit && (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit'),
            // }}
            variant={"standard"}
            style={{ width: '50%' }}
            error={!!row.quantityError}
            helperText={row.quantityError}
          />
          <IconButton
            onClick={() => removeRow(index)}
            disabled={rows.length === 1}
            style={{ marginLeft: 'auto' }}
          >
            <RemoveCircleOutline />
          </IconButton>
        </div>
      ))}
    </div>
  );
});

export default KitDetailsForm;
